import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-4 py-8 sm:py-14 items-center justify-center" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #001a0d 30%, #000d08 60%, #0a0a0a 100%)'
  }} data-id="element-112">
      {/* Social proof badge */}
      <div className="mb-3" data-id="element-113">
        <span className="inline-block bg-[#00C853]/10 text-[#00C853] font-bold text-[11px] sm:text-sm px-3 py-1 rounded-full border border-[#00C853]/20" data-id="element-114">
          ✅ +500 profes de Baby Fútbol ya lo usan en toda Argentina
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-5xl sm:text-5xl md:text-7xl lg:text-8xl mb-0 text-[26px] leading-tight" data-id="element-115">
        Todo tu año de Baby Fútbol
        <br data-id="element-116" />
        <span className="text-[#00C853]" data-id="element-117">resuelto.</span>
      </h1>

      {/* Mockup image — LCP element */}
      <div className="w-full max-w-[220px] sm:max-w-[280px] md:max-w-xs mx-auto my-3 sm:my-4" style={{
      aspectRatio: '1/1'
    }} data-id="element-118">
        <img src="https://cdn.magicpatterns.com/uploads/hDPfFeE7vevz6Hx3naGSjk/Diseno_sin_titulo_(17).png" alt="PROFEPACK MegaPack BabyFútbol Listo — Combo Completo" className="w-full h-full object-contain" width={400} height={400} loading="eager" decoding="async" fetchPriority="high" data-id="element-119" />
      </div>

      {/* Value proposition — tight, number-driven */}
      <p className="text-white text-sm sm:text-lg max-w-xl mb-1 leading-snug" data-id="element-120">
        <strong className="text-[#00C853]" data-id="element-121">
          6 tomos · 480 sesiones · 40 semanas
        </strong>
        <br data-id="element-122" />
        Planificación anual completa + bonos + estrategia de partido.
        <br data-id="element-123" />
        <span className="text-gray-300" data-id="element-124">
          Sin buscar. Sin improvisar. Sin perder domingos.
        </span>
      </p>

      {/* Pills */}
      <div className="flex flex-wrap my-2 gap-1.5 items-center justify-center max-w-[340px] sm:max-w-none mx-auto" data-id="element-125">
        <span className="bg-black/50 border border-[#00C853]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-126">
          📄 100% PDF
        </span>
        <span className="bg-black/50 border border-[#00C853]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-127">
          ⚡ Acceso inmediato
        </span>
        <span className="bg-black/50 border border-[#00C853]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-128">
          🇦🇷 4 a 12 años
        </span>
      </div>

      {/* Price anchor + urgency */}
      <div className="flex items-center justify-center gap-2 mt-2 mb-3" data-id="element-129">
        <span className="text-gray-400 line-through text-sm sm:text-base" data-id="element-130">
          $69.000
        </span>
        <span className="text-white font-black text-xl sm:text-2xl" data-id="element-131">
          Desde $19.990
        </span>
        <span className="bg-red-500/20 text-red-400 text-[10px] sm:text-xs font-bold px-2 py-0.5 rounded border border-red-500/30" data-id="element-132">
          61% OFF
        </span>
      </div>
      <p className="text-[#FF8A80] text-xs sm:text-sm font-semibold mb-3" data-id="element-133">
        ⏰ Precio de lanzamiento — quedan pocos cupos
      </p>

      {/* CTA Button */}
      <a href="#pricing" className="btn-green-pulse bg-[#00C853] text-black font-black text-base sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#00E676] transition-colors inline-block mb-2 w-full sm:w-auto max-w-sm" data-id="element-134">
        ⚽ → QUIERO MI MEGAPACK AHORA
      </a>
      <p className="text-gray-300 text-xs sm:text-sm mb-4" data-id="element-135">
        🛡️ Garantía 7 días sin preguntas · Devolución total si no te sirve
      </p>

      {/* Trust badges */}
      <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 text-gray-400 text-[10px] sm:text-xs" data-id="element-136">
        <span data-id="element-137">🔒 Pago seguro</span>
        <span data-id="element-138">⚡ Acceso en 5 min</span>
        <span data-id="element-139">💳 Mercado Pago · Tarjeta · Transferencia</span>
      </div>
    </section>;
}